import { useId } from 'react';
import { Input } from '@/components/ui/input';

interface TextFilterProps {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  className?: string;
  name?: string;
  id?: string;
}

export function TextFilter({
  value,
  onChange,
  placeholder = 'Enter value',
  className = 'w-64',
  name,
  id
}: TextFilterProps) {
  const generatedId = useId();
  const inputId = id || generatedId;
  const inputName = name || placeholder?.toLowerCase().replace(/\s+/g, '-') || 'text-filter';

  return (
    <Input
      id={inputId}
      name={inputName}
      type="text"
      value={value}
      onChange={(e) => onChange(e.target.value)}
      placeholder={placeholder}
      className={className}
    />
  );
}
